import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from 'vue';
import { IonButton } from '@ionic/vue';
import userAuth from '@/composables/userAuth';
import { useFixedBannerHeight } from '@/composables/useFixedBannerHeight';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupervisionBanner',
  setup(__props) {

const bannerRef = ref<HTMLElement | null>(null);

const meta = computed(() => {
  const raw = localStorage.getItem('supervision');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as { supervisor_name?: string };
  } catch {
    return null;
  }
});

useFixedBannerHeight(
  bannerRef,
  '--galidancia-supervision-banner-height',
  () => meta.value !== null,
);

const currentUserName = computed(() => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.name || 'usuario';
  } catch {
    return 'usuario';
  }
});

function exit(): void {
  userAuth().logout();
}

return (_ctx: any,_cache: any) => {
  return (meta.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "bannerRef",
        ref: bannerRef,
        class: "supervision-banner",
        role: "status"
      }, [
        _createElementVNode("span", null, [
          _createTextVNode(" Modo supervisión: estás viendo la app como "),
          _createElementVNode("strong", null, _toDisplayString(currentUserName.value), 1),
          _createTextVNode(" (supervisor: " + _toDisplayString(meta.value.supervisor_name) + ") ", 1)
        ]),
        _createVNode(_unref(IonButton), {
          size: "small",
          fill: "solid",
          color: "light",
          onClick: exit
        }, {
          default: _withCtx(() => [
            _createTextVNode("Salir")
          ]),
          _: 1
        })
      ], 512))
    : _createCommentVNode("", true)
}
}

})